
export const defaultCountryCodes = [
  "ae",
  "ar",
  "at",
  "au",
  "bd",
  "be",
  "br",
  "ca",
  "ch",
  "cl",
  "cn",
  "co",
  "de",
  "dk",
  "eg",
  "es",
  "fi",
  "fr",
  "gr",
  "hk",
  "id",
  "ie",
  "il",
  "in",
  "it",
  "jo",
  "jp",
  "ke",
  "kr",
  "mx",
  "my",
  "ng",
  "nl",
  "no",
  "nz",
  "pe",
  "ph",
  "pk",
  "pl",
  "pt",
  "ru",
  "sa",
  "se",
  "sg",
  "th",
  "tr",
  "tw",
  "ua",
  "uk",
  "us",
  "ve",
  "vn",
  "za"
];